module.exports = __webpack_public_path__ + "img/InsafetyMap.d0942e09.png";